import { create } from 'zustand';

export const useAssetGroupStore = create((set) => ({
    // Data State
    items: [],
    loading: false,
    error: null,
    success: null,

    // UI State
    isFormOpen: false,
    selectedItem: null,
    isDetailsOpen: false,
    stats: null,

    // Pagination & Filtering
    pagination: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 10,
        hasNextPage: false,
        hasPreviousPage: false,
    },
    sorting: {
        sortBy: 'createdAt',
        sortDirection: 'desc'
    },
    search: '',
    columnFilters: {},
    uniqueValues: {},

    // Actions
    setData: (items) => set({ items }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    setSuccess: (success) => set({ success }),
    setStats: (stats) => set({ stats }),

    setPagination: (pagination) => set((state) => ({
        pagination: { ...state.pagination, ...pagination }
    })),

    setSorting: (sorting) => set((state) => ({
        sorting: { ...state.sorting, ...sorting }
    })),

    setSearch: (search) => set({ search }),

    setColumnFilters: (filters) => set({ columnFilters: filters }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues }),

    // Form Helpers
    openForm: (item = null) => set({ isFormOpen: true, selectedItem: item }),
    closeForm: () => set({ isFormOpen: false, selectedItem: null }),

    // Details Helpers
    openDetailsDialog: (item) => set({ isDetailsOpen: true, selectedItem: item }),
    closeDetailsDialog: () => set({ isDetailsOpen: false, selectedItem: null }),

    // Clearers
    clearError: () => set({ error: null }),
    clearSuccess: () => set({ success: null }),
    reset: () => set({
        items: [],
        loading: false,
        error: null,
        success: null,
        isFormOpen: false,
        isDetailsOpen: false,
        selectedItem: null,
        search: '',
        columnFilters: {},
        uniqueValues: {},
        pagination: {
            currentPage: 1,
            totalPages: 1,
            totalItems: 0,
            itemsPerPage: 10,
            hasNextPage: false,
            hasPreviousPage: false,
        }
    })
}));
